import { Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ModalAccionesUsuarioComponent} from '../modal-acciones-usuario/modal-acciones-usuario.component'
import {DetalleServiceService} from '../detalle-service.service'
import {ModalHerramientasYControlesComponent}from '../modal-herramientas-ycontroles/modal-herramientas-ycontroles.component'
import {ModalDetallesActividadComponent} from '../modal-detalles-actividad/modal-detalles-actividad.component'
import {Router}from'@angular/router';

@Component({
  selector: 'app-componente-data7',
  templateUrl: './componente-data7.component.html',
  styleUrls: ['./componente-data7.component.scss']
})
export class ComponenteData7Component implements OnInit {


  fechainicio
  fechafinal
  status
  fechasolicitud
  horarioDeTrabajo
  fechacierre
  comentarioCierre
  cuenca
  unidadDeNegocio
  pozoSeleccionado
  nombreSolicitante
  solicitante
  empresa
  descripcionPTW
  autoridadHSE  
  emailautoridadHSE
  autoridadAislante
  emailautoridadAislante
  autoridadArea
  emailautoridadArea
  gerenteCampo
  autoridadAreaLocal 
  emailautoridadAreaLocal
  arraydepasos
  arrayDeEmpleados=[]
  
  dictamenAutAislante={comentario:'',vistobueno:false}
  dictamenAutArea={comentario:'',vistobueno:false}
  dictamenAutAreaLocal={comentario:'',vistobueno:false}
  dictamenAutHSE={comentario:'',vistobueno:false}
  dictamenGerenteCampo={comentario:'',vistobueno:false}

  revalidacionSolicitada

  requiereGerenteCampo=false
  
  requiereAutoridadAislante=false
  autoridadAislanteSeleccionada=undefined
  emailautoridadAislanteSeleccionada=''

  gerenteCampoSeleccionado=undefined
  
  colordelpaso1='rgb(214, 45, 22)'
  colordelpaso2='rgb(214, 45, 22)'
  colordelpaso3='rgb(214, 45, 22)'
  colordelpaso4='rgb(214, 45, 22)'
  colordelpaso5='rgb(214, 45, 22)'


  constructor(private modalService: NgbModal, public detalleService:DetalleServiceService, private router:Router) { }

  ngOnInit(): void {
    this.asignavalores()
  }

  asignavalores(){
    this.fechasolicitud = this.detalleService.dataPTW.fechasolicitud
    this.fechainicio = this.detalleService.dataPTW.fechainicio
    this.fechafinal = this.detalleService.dataPTW.fechafinal
    this.horarioDeTrabajo = this.detalleService.dataPTW.horarioDeTrabajo
    this.cuenca = this.detalleService.dataPTW.cuenca
    this.unidadDeNegocio = this.detalleService.dataPTW.unidadDeNegocio
    this.pozoSeleccionado = this.detalleService.dataPTW.pozoSeleccionado
    this.nombreSolicitante = this.detalleService.dataPTW.nombreSolicitante
    this.solicitante = this.detalleService.dataPTW.solicitante
    this.empresa = this.detalleService.dataPTW.empresa
    this.status = this.detalleService.dataPTW.status
    this.descripcionPTW = this.detalleService.dataPTW.descripcionPTW

    this.autoridadHSE = this.detalleService.dataPTW.autoridadHSE
    this.autoridadArea = this.detalleService.dataPTW.autoridadArea
    this.autoridadAislante = this.detalleService.dataPTW.autoridadAislante
    this.autoridadAreaLocal = this.detalleService.dataPTW.autoridadAreaLocal
    this.gerenteCampo=this.detalleService.dataPTW.gerenteCampo

    this.emailautoridadHSE = this.detalleService.dataPTW.emailautoridadHSE
    this.emailautoridadAislante = this.detalleService.dataPTW.emailautoridadAislante
    this.emailautoridadArea = this.detalleService.dataPTW.emailautoridadArea
    this.emailautoridadAreaLocal = this.detalleService.dataPTW.emailautoridadAreaLocal

    this.arraydepasos = this.detalleService.dataPTW.arraydepasos
    this.arrayDeEmpleados = this.detalleService.dataPTW.arrayDeEmpleados

    this.dictamenAutAislante= this.detalleService.dataPTW.dictamenAutAislante
    this.dictamenAutArea= this.detalleService.dataPTW.dictamenAutArea
    this.dictamenAutAreaLocal= this.detalleService.dataPTW.dictamenAutAreaLocal
    this.dictamenAutHSE= this.detalleService.dataPTW.dictamenAutHSE
    this.dictamenGerenteCampo= this.detalleService.dataPTW.dictamenGerenteCampo

    this.revalidacionSolicitada= this.detalleService.dataPTW.revalidacionSolicitada
    this.fechacierre= this.detalleService.dataPTW.fechacierre
    this.comentarioCierre= this.detalleService.dataPTW.comentarioCierre
    this.requiereAutoridadAislante= this.detalleService.dataPTW.requiereAutoridadAislante
    
    this.requiereGerenteCampo=this.detalleService.dataPTW.requiereGerenteCampo
    this.asignacoloresdepasos()
    this.recargaArraydeTrabajadores(this.detalleService.dataPTW.arrayDeEmpleados)
  }


  recargaArraydeTrabajadores(arrayDeEmpleados){
    console.log("ARRAYDEEMPLEADOS"+arrayDeEmpleados)
      arrayDeEmpleados.forEach((item,index)=>{
        let querydeEmpleado= firebase.firestore().collection("trabajadores").doc(item.id)
        querydeEmpleado.get().then((doc)=>{
          // this.arrayDeEmpleados.push(doc.data())
          this.arrayDeEmpleados[index].arl = doc.data().arl
          this.arrayDeEmpleados[index].nombre = doc.data().nombre
          this.arrayDeEmpleados[index].telefono = doc.data().telefono
          this.arrayDeEmpleados[index].fechaAfiliacionARL = doc.data().fechaAfiliacionARL
          this.arrayDeEmpleados[index].urlParafiscales = doc.data().urlParafiscales
          this.arrayDeEmpleados[index].urlCertificadoAlturas = doc.data().urlCertificadoAlturas
          this.arrayDeEmpleados[index].urlCertificadoAptitud = doc.data().urlCertificadoAptitud
          this.arrayDeEmpleados[index].urlCertificadoIzaje = doc.data().urlCertificadoIzaje
          this.arrayDeEmpleados[index].urlCertificadoCONTE = doc.data().urlCertificadoCONTE
          this.arrayDeEmpleados[index].urlCertificadoConfinados = doc.data().urlCertificadoConfinados
          this.arrayDeEmpleados[index].urlCertificadoAptitudConfinados = doc.data().urlCertificadoAptitudConfinados
          this.arrayDeEmpleados[index].urlCertificadoEquiposConfinados = doc.data().urlCertificadoEquiposConfinados
        }).catch((err)=>{
          console.log(err)
        })
      })
   }

   asignacoloresdepasos(){
    if(this.requiereAutoridadAislante==false){this.colordelpaso1 = '#cfcfcf'}else
    if(this.dictamenAutAislante.vistobueno == true){this.colordelpaso1 = '#5ba119'}else
    if(this.dictamenAutAislante.vistobueno == false){this.colordelpaso1 = '#f04141'}
    
    if(this.dictamenAutHSE.vistobueno == true){this.colordelpaso2 = '#5ba119'}else
    if(this.dictamenAutHSE.vistobueno == false){this.colordelpaso2 = '#f04141'}
  
    if(this.dictamenAutArea.vistobueno == true){this.colordelpaso3 = '#5ba119'}else
    if(this.dictamenAutArea.vistobueno == false){this.colordelpaso3 = '#f04141'}
    
    if(this.requiereGerenteCampo == false){this.colordelpaso4 = '#cfcfcf'}else
    if(this.dictamenGerenteCampo.vistobueno == true){this.colordelpaso4 = '#5ba119'}else
    if(this.dictamenGerenteCampo.vistobueno == false){this.colordelpaso4 = '#f04141'}
  
    if(this.dictamenAutAreaLocal.vistobueno == true){this.colordelpaso5 = '#5ba119'}else
    if(this.dictamenAutAreaLocal.vistobueno == false){this.colordelpaso5 = '#f04141'}
  }

  async  presentmodalHerramientasYControles(actividad,indiceActividad,item,i) {

    const modalRef = this.modalService.open(ModalHerramientasYControlesComponent, { size: 'xl', scrollable: true });
    modalRef.componentInstance.actividad = actividad;//pasamos al modal el parámetro
    modalRef.componentInstance.indiceActividad = indiceActividad;//pasamos al modal el parámetro
    modalRef.componentInstance.trabajador = item;//pasamos al modal el parámetro
    modalRef.componentInstance.indiceTrabajador = i;//pasamos al modal el parámetro
    modalRef.componentInstance.arrayDeEmpleados = this.arrayDeEmpleados;//pasamos al modal el parámetro

    //para recibir data desde el modal
    modalRef.result.then((result) => {
      if (result=="OK") {

      }
      });
  }

  detalles(usuario){
   
  }


  async presentmodalActividadesParaEditar(actividad,indiceactividad,trabajador,indicetrabajador,crearOeditar){
    
    const modalRef = this.modalService.open(ModalDetallesActividadComponent, { size: 'xl', scrollable: true });
    modalRef.componentInstance.actividadParaEditar = actividad;//pasamos al modal el parámetro
    modalRef.componentInstance.indiceActividadParaEditar = indiceactividad;//pasamos al modal el parámetro
    modalRef.componentInstance.trabajador = trabajador;//pasamos al modal el parámetro
    modalRef.componentInstance.indiceTrabajador = indicetrabajador;//pasamos al modal el parámetro
    modalRef.componentInstance.arrayDeEmpleados = this.arrayDeEmpleados;//pasamos al modal el parámetro

    //para recibir data desde el modal
    modalRef.result.then((result) => {
      if (result=="OK") {

      }
      });
  }






 
  gotolista(){
    this.router.navigateByUrl('/data-component');
  }



}
